<div class="row mx-1">
    <div class="mt-3 w-auto mx-auto col">
        <div class="alert alert-secondary pb-0" role="alert">
            <span class="fa fa-ban h4">
                &nbsp;&nbsp;-&nbsp;&nbsp;Infelizmente não conseguimos processar sua solitação, favor retorne a página inicial <a href="#" (click)="paginaHome()">clicando aqui.</a> 
            </span>
        </div>
    </div>
</div>

